import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { BehaviorSubject } from 'rxjs';
import tinycolor from 'tinycolor2';
import { getRGBColor } from 'app/shared/style';
import * as CryptoJS from 'crypto-js';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

function _window(): any {
    // return the global native browser window object
    return window;
}

@Injectable({ providedIn: 'root' })
export class ApiService {
    isLoadSettings = new BehaviorSubject<Boolean>(false);
    checkSubscriotion = new BehaviorSubject<boolean>(true);
    isSubscriptionOver = new BehaviorSubject<boolean>(false);
    isLogginFirstTime = new BehaviorSubject<boolean>(true);
    isLoggedIn = new BehaviorSubject<number>(0);
    baseUrl: any = environment.baseUrl;
    settingsData: any;
    parseData: any;
    userToken: any;
    currentPlanLoaded = new BehaviorSubject<boolean>(false);
    isLoggedOut = new BehaviorSubject<number>(0);
    activatedPlan: any;
    isPlanLoaded = new BehaviorSubject<boolean>(false);
    allPlans: any;
    allAddon: any;
    toggleMatDrawer = new BehaviorSubject<boolean>(false);
    MatDrawerMode = new BehaviorSubject<string>('');
    refreshData = new BroadcastChannel('refresh');
    plansData: any;

    // inboxes
    activeTicketId: any = 0;
    ticketUnreadMsg = new BehaviorSubject<number>(0);
    isLoadingStatus = new BehaviorSubject<boolean>(false);
    changeInboxStatus:any;
    changeActiveChatId: any;

    isSetPassword:any;
    folderId: any;
    sequencesValidation = new BehaviorSubject<boolean>(false);
    clientHeight: number = 1050;
    clientWidth: number = 1050;
    campaignId: any;
    campaignName: any;
    allCampaign: any;

    // Prospect Finder
    prospectFinderPreUrl:any;

    constructor(
        private httpClient: HttpClient,
        @Inject(PLATFORM_ID) private platformId: object,
        private translateSer: TranslateService
    ) {
    }

    getData(data) {
        return this.httpClient.get(this.baseUrl + data);
    }

    postData(url: any, data: any) {
        return this.httpClient.post(this.baseUrl + url, data);
    }

    setPassword(url:any, data:any, memberId:any) {
        let headers = new HttpHeaders({
            Accept: 'application/json',
            'X-Member': memberId });
        let options = { headers: headers };
        return this.httpClient.post(this.baseUrl + url, data, options);
    }

    computeColorPalette(color = '#FFEA00', themeClass?) {
        let passedColor = color ;
        console.log(
            'color function settingsData',
            this.settingsData && this.settingsData.color
        );
        console.log(
            'color function local storage',
            localStorage.getItem('themeColor')
        );
        console.log('color', color);
        console.log('color function passed color', passedColor);
        console.log(
            'color function condition',
            this.settingsData && this.settingsData.color
                ? this.settingsData.color
                : localStorage.getItem('themeColor') ?? passedColor
        );

        document.body.style.setProperty(`--partnerReach-primary`, color);
        document.body.style.setProperty(
            `--partnerReach-primary-rgb`,
            getRGBColor(color, 'primary').slice(0, -1)
        );
        document.body.style.setProperty(
            `--partnerReach-primary-500-rgb`,
            getRGBColor(color, 'primary').slice(0, -1)
        );
        document.body.style.setProperty(`--partnerReach-primary`, color);
        document.body.style.setProperty('--primary', color);
        document.body.style.setProperty('--partnerReach-theme', color);
        document.body.style.setProperty(
            '--mdc-linear-progress-active-indicator-color',
            color
        );
        document.body.style.setProperty(
            '--mdc-circular-progress-active-indicator-color',
            color
        );
        document.body.style.setProperty(
            '--mdc-radio-selected-icon-color',
            color
        );
        if (themeClass == 'theme-partnerReach')
            color =
                this.settingsData && this.settingsData.color
                    ? this.settingsData.color
                    : localStorage.getItem('themeColor') ?? passedColor;
        return [
            this.getColorObject(tinycolor(color).lighten(45), '50', themeClass),
            this.getColorObject(
                tinycolor(color).lighten(40),
                '100',
                themeClass
            ),
            this.getColorObject(
                tinycolor(color).lighten(30),
                '200',
                themeClass
            ),
            this.getColorObject(
                tinycolor(color).lighten(20),
                '300',
                themeClass
            ),
            this.getColorObject(
                tinycolor(color).lighten(10),
                '400',
                themeClass
            ),
            this.getColorObject(tinycolor(color), '500', themeClass),
            this.getColorObject(tinycolor(color).darken(10), '600', themeClass),
            this.getColorObject(tinycolor(color).darken(20), '700', themeClass),
            this.getColorObject(tinycolor(color).darken(30), '800', themeClass),
            this.getColorObject(tinycolor(color).darken(40), '900', themeClass),
        ];
    }
    getColorObject(
        value: tinycolor.Instance,
        name: string,
        themeClass: string
    ): any {
        setTimeout(() => {
            const c = tinycolor(value);
            let t = setInterval(() => {
                document.documentElement.style.setProperty(
                    `--partnerReach-primary-${name}-rgb`,
                    getRGBColor(c.toHexString(), 'primary').slice(0, -1)
                );
                document.documentElement.style.setProperty(
                    `--partnerReach-primary-${name}`,
                    c.toHexString()
                );
                if (name == '500') {
                    document.documentElement.style.setProperty(
                        `--partnerReach-primary-rgb`,
                        getRGBColor(c.toHexString(), 'primary').slice(0, -1)
                    );
                    document.documentElement.style.setProperty(
                        `--partnerReach-primary`,
                        c.toHexString()
                    );
                    document.documentElement.style.setProperty(
                        '--primary',
                        c.toHexString()
                    );
                    document.documentElement.style.setProperty(
                        '--partnerReach-theme',
                        c.toHexString()
                    );
                    document.documentElement.style.setProperty(
                        '--mdc-linear-progress-active-indicator-color',
                        c.toHexString()
                    );
                    document.documentElement.style.setProperty(
                        '--mdc-circular-progress-active-indicator-color',
                        c.toHexString()
                    );
                    document.documentElement.style.setProperty(
                        '--mdc-radio-selected-icon-color',
                        c.toHexString()
                    );
                }
                if (document.getElementsByClassName(themeClass)) {
                    let classArray = Array.from(
                        document.getElementsByClassName(
                            themeClass
                        ) as HTMLCollectionOf<HTMLElement>
                    );
                    classArray.forEach((abc: any) => {
                        abc.style.setProperty(
                            `--partnerReach-primary-${name}-rgb`,
                            getRGBColor(c.toHexString(), 'primary').slice(0, -1)
                        );
                        abc.style.setProperty(
                            `--partnerReach-primary-${name}`,
                            c.toHexString()
                        );
                        if (name == '500') {
                            abc.style.setProperty(
                                `--partnerReach-primary`,
                                c.toHexString()
                            );
                            abc.style.setProperty(
                                '--partnerReach-primary-rgb',
                                getRGBColor(c.toHexString(), 'primary').slice(
                                    0,
                                    -1
                                )
                            );
                        }
                    });
                    // console.log(name, themeClass, c.toHexString())
                    clearInterval(t);
                }
            }, 1000);
            return {
                name,
                hex: c.toHexString(),
                rgb: c.toRgbString(),
                rgbCode: getRGBColor(c.toHexString(), 'primary').slice(0, -1),
                isDarkContrast: c.isLight(),
            };
        }, 10);
    }

    encryptId(id) {
        var DataKey = CryptoJS.enc.Utf8.parse(
            'xUgtF7AUPX4KXCFc66xDIfZkD80Y2FxM'
        );
        var DataVector = CryptoJS.enc.Utf8.parse('1eaJvjEqxGKFj4ud');
        var encrypted = CryptoJS.AES.encrypt(id.toString(), DataKey, {
            iv: DataVector,
        });
        let encryptedID = encrypted
            .toString()
            .replace(/\+/g, 'xMl3Jk')
            .replace(/\//g, 'Por21Ld')
            .replace(/=/g, 'Ml32');
        return encryptedID;
    }
    getdecryptedId(id) {
        let newId = id
            .toString()
            .replace(/xMl3Jk/g, '+')
            .replace(/Por21Ld/g, '/')
            .replace(/Ml32/g, '=');
        var DataKey = CryptoJS.enc.Utf8.parse(
            'xUgtF7AUPX4KXCFc66xDIfZkD80Y2FxM'
        );
        var DataVector = CryptoJS.enc.Utf8.parse('1eaJvjEqxGKFj4ud');
        var decrypted = CryptoJS.AES.decrypt(
            decodeURIComponent(newId),
            DataKey,
            { iv: DataVector }
        );
        var decrypt = CryptoJS.enc.Utf8.stringify(decrypted);
        return decrypt;
    }

    doFocusInput(input) {
        console.log('input', input);
        if (input && input.nativeElement) {
            input.nativeElement.focus();
        }
    }

    removeInjectedStyles() {
        setTimeout(() => {
          const injectedStyles = document.querySelectorAll('style[data-apolloio="true"]');
          injectedStyles.forEach(styleTag => {
            styleTag.parentNode.removeChild(styleTag);
          });
        }, 500);
      }

      checkCSSIssue(){
        setTimeout(() => {
            this.removeInjectedStyles();
        }, 2000);
      }

      getTranslatedData(object, key) {
        let translatedObjcet
        this.translateSer.get(object).subscribe((res) => {
          translatedObjcet = res
          // console.log(key,translatedObjcet[key])
    
        })
        return translatedObjcet[key]
      }
}
